import PropTypes from 'prop-types';

export const locationInputPropTypes = {
  defaultLocation: PropTypes.string,
  formActive: PropTypes.bool, // true when other inputs in the form are focused
  value: PropTypes.object,
  setValue: PropTypes.func, // ({ label, value: { location obj } }) => void
  setActiveInput: PropTypes.func, // (string) => void
  setValidator: PropTypes.func, // (validatorFn) => boolean
  currentLocale: PropTypes.shape({
    translations: PropTypes.string, // 'de-DE'
    url_prefix: PropTypes.string, // 'de'
    zendesk_url_locale: PropTypes.string, // 'en-us',
    region: PropTypes.string, // 'Europe',
    language: PropTypes.string, // 'Deutsch',
    country: PropTypes.string, // 'Deutschland',
    locale: PropTypes.string // 'de-DE'
  })
};
